import { Component, ElementRef, ViewChild, AfterViewChecked, OnDestroy, HostListener, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';
import { HelpService, HelpArticle } from './help.service';
import { GlobalService } from '../services/global.service';
import { HelpArticleComponent } from './help-article.component';

@Component({selector: 'app-help-host', standalone: true, imports: [CommonModule, FormsModule, A11yModule, HelpArticleComponent], templateUrl: './help-host.component.html', styleUrls: ['./help-host.component.scss']})
export class HelpHostComponent implements AfterViewChecked, OnDestroy {
  help = inject(HelpService);
  global = inject(GlobalService);
  @ViewChild('contents') contents?: ElementRef<HTMLElement>;
  @ViewChild('reading') reading?: ElementRef<HTMLElement>;
  @ViewChild('readingTitle') readingTitle?: ElementRef<HTMLElement>;
  private focusReading = false;
  private previous = '';
  private frame = 0;
  private resizeFrame = 0;
  get article() { return this.help.query.trim() ? undefined : this.help.article; }
  paragraphs(article: HelpArticle) { return article.body.split('\n').filter(Boolean); }
  minutes(article: HelpArticle) { return Math.max(1, Math.ceil([article.body, ...(article.steps || []), ...(article.callouts || []).map(tip => tip.text)].join(' ').split(/\s+/).length / 200)); }
  related(article: HelpArticle) { return (article.related || []).map(id => this.help.articles.find(item => item.id === id)).filter((item): item is HelpArticle => !!item); }
  inGroup(group: string) { return this.help.matches.filter(article => article.group === group); }
  allInGroup(group: string) { return this.help.articles.filter(article => article.group === group); }
  select(id: string) { this.focusReading = true; this.help.select(id); }
  adjacent(direction: number) { const index = this.help.articles.findIndex(article => article.id === this.help.selected); return this.help.articles[index + direction]; }
  ngAfterViewChecked() {
    const key = this.help.isOpen + ':' + this.help.selected + ':' + this.help.query + ':' + this.help.locale.version;
    if (key === this.previous) return;
    this.previous = key;
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => {
      this.scrollSelectedTopic();
      this.reading?.nativeElement.scrollTo({top: 0});
      if (this.help.isOpen && this.focusReading) this.readingTitle?.nativeElement.focus({preventScroll: true});
      this.focusReading = false;
    });
  }
  private scrollSelectedTopic() {
    const pane = this.contents?.nativeElement;
    const selected = pane?.querySelector<HTMLElement>('[aria-current="page"]');
    if (pane?.getClientRects().length && selected) {
      const a = selected.getBoundingClientRect(), b = pane.getBoundingClientRect();
      pane.scrollTop += a.top - b.top - pane.clientHeight / 2 + a.height / 2;
    }
  }
  @HostListener('window:resize') syncContents() {
    cancelAnimationFrame(this.resizeFrame);
    this.resizeFrame = requestAnimationFrame(() => this.scrollSelectedTopic());
  }
  print() { window.print(); }
  ngOnDestroy() { cancelAnimationFrame(this.frame); cancelAnimationFrame(this.resizeFrame); this.help.close(false); }
}
